
export function tagStyles() {
  return {
    collected_by_tag: {
    },
    exposure_type_tag: {
    },
    general_data_type_tag: {
    },
    phenotype_type_tag: {
    },
    sample_type_tag: {
    },
    species_tag: {
    },
    sponsor_tag: {
    },
    study_type_tag: {
    },
    truth_tag: {
    }
  }
}

export function formStyles() {
  return {
    dark_title: {
      color: "darkslategray"
    },
    required_title: {
      color: 'darkslategray'
    },
    required_title_empty: {
      color: 'red'
    },
    non_required_title: {
      color: "darkslategray"
    },
    numbered_section: {
      color: "darkslategray"
    },
    fieldDescription: {
      color: 'darkgrey',
      fontSize: 'calc(11px + 0.3vmin)',
      margin: '0 0 5px 4px',
    },
  }
}

export function classificationStyles() {
  // https://www.astrouxds.com/components/classification-markings/#overall-marking-background-information
  return {
    unclassified: {
      backgroundColor: '#007a33 !important',
      color: 'white !important'
    },
    controlled: {
      backgroundColor: '#502b85 !important',
      color: 'white !important'
    },
    confidental: {
      backgroundColor: '#0033a0 !important',
      color: 'white !important'
    },
    secret: {
      backgroundColor: '#c8102e !important',
      color: 'white !important'
    },
    top_secret: {
      backgroundColor: '#ff8c00 !important',
      color: 'black !important'
    },
    top_secret_sci: {
      backgroundColor: '#fc383a !important',
      color: 'black !important'
    }
  }
}